import React, { createContext, useState, useContext } from "react";

const AppContext = createContext();

export const AppProvider = ({ children }) => {
    const [examLevelCourse, setExamLevelCourse] = useState("");

    const values = {
        examLevelCourse,
        setExamLevelCourse
    };

    return (
        <AppContext.Provider value={values}>
            {children}
        </AppContext.Provider>
    )
}

export const useAppContext = () => useContext(AppContext);